// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.meter_green_KIMF6 {
    fill: rgb(171, 220, 170);
    stroke: rgb(174, 211, 168);
}

.meter_yellow_apqdC {
    fill: rgb(251, 219, 130);
    stroke: rgb(239, 212, 134);
}

.meter_red_l1IMM {
    fill: rgb(251, 194, 142);
    stroke: rgb(235, 189, 142);
}

.meter_mask-container_TBjcW {
    position: relative;
}

.meter_mask_Tt0aS {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    transform-origin: top;
    will-change: transform;
    background: var(--ui-primary);
    opacity: 0.75;
}
`, "",{"version":3,"sources":["webpack://./src/components/meter/meter.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,sBAAsB;IACtB,6BAA6B;IAC7B,aAAa;AACjB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.green {\n    fill: rgb(171, 220, 170);\n    stroke: rgb(174, 211, 168);\n}\n\n.yellow {\n    fill: rgb(251, 219, 130);\n    stroke: rgb(239, 212, 134);\n}\n\n.red {\n    fill: rgb(251, 194, 142);\n    stroke: rgb(235, 189, 142);\n}\n\n.mask-container {\n    position: relative;\n}\n\n.mask {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    transform-origin: top;\n    will-change: transform;\n    background: var(--ui-primary);\n    opacity: 0.75;\n}\n"],"sourceRoot":""}]);
// Exports
export var green = `meter_green_KIMF6`;
export var yellow = `meter_yellow_apqdC`;
export var red = `meter_red_l1IMM`;
var _1 = `meter_mask-container_TBjcW`;
export { _1 as "mask-container" };
export var maskContainer = `meter_mask-container_TBjcW`;
export var mask = `meter_mask_Tt0aS`;
export default ___CSS_LOADER_EXPORT___;
